export default __webpack_public_path__ + "static/homepage-video-78e9ae82ab41e2fdfe0f6e0e379ae514.mp4";